<header class="header header-8">
  <div class="branding">
      <img class="logo" [src]="logo" alt="logo">
  </div>
  <div class="header-nav" >
    <table aria-describedby="navigation">
      <tr><th>
        <div class="header-title"><p>Data Collection & Information System</p></div>
      </th></tr>
      <tr><td>
        <clr-dropdown class="dropdown" *ngFor="let item of navbarMenuItems">
          <a  class="nav-link"  [class.disabled]="true">
            <span class="nav-text"> {{item.text}} </span>
          </a>
          </clr-dropdown>
      </td></tr>
    </table>
  </div>
  <div class="header-actions" style="margin-top:0.5rem;">
    <clr-dropdown>
      <a class="nav-link nav-icon-text" clrDropdownTrigger>
        <div class="clr-row">
          <div class="clr-col-3">
            <clr-icon shape="user" class="user-icon is-solid"></clr-icon>
          </div>
          <div class="clr-col-9 pl-0 pt-1 username">
            {{username}}
          </div>
        </div>
      </a>
      <clr-dropdown-menu clrPosition="bottom-right">
        <div class="card dropdown-card">
          <div class="card-block">
            <button id="btn-logout" class="btn btn-link" (click)="logout()">Logout</button>
          </div>
        </div>
      </clr-dropdown-menu>
    </clr-dropdown>

  </div>
</header>